import { type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { linkVariants } from './variants'

export type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  VariantProps<typeof linkVariants>

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ variant = 'hyperlink', className, ...props }, ref) => (
    <a ref={ref} className={linkVariants({ variant, className })} {...props} />
  ),
)
Link.displayName = 'Link'
